import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, toRefs } from 'vue';
import { InputNumberInputEvent } from 'primevue/inputnumber';
import { useProgressReportDropdown } from '@/composables';

interface Props {
  goalId: undefined | number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ProgressReportQuantity',
  props: {
    goalId: { default: undefined }
  },
  setup(__props: any) {

const props = __props;

const { goalId } = toRefs(props);

const quantity = ref();

const onInput = (event: InputNumberInputEvent) => useProgressReportDropdown(goalId, 'quantity').onChange(event);

return (_ctx: any,_cache: any) => {
  const _component_InputNumber = _resolveComponent("InputNumber")!

  return (_openBlock(), _createBlock(_component_InputNumber, {
    modelValue: quantity.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((quantity).value = $event)),
    placeholder: "Quantity",
    onInput: onInput
  }, null, 8, ["modelValue"]))
}
}

})